import React, { ReactNode } from 'react'
import { useStyles } from './RoutingApp.styles'
import { HeaderRoutingApp } from '../HeaderRoutingWrapper'
import { WithErrorBoundary } from '../WithErrorBoundary'
import clsx from 'clsx'
import type { CustomNavButtonProp } from './types'

export type { CustomNavButtonProp }

interface RoutingAppProps extends Partial<ReactChildrenProps> {
  title?: string | ReactNode
  titleIconOrBadge?: React.FC
  actions?: React.FC
  component?: React.FC
  isSidePanelOpened?: boolean
  subHeading?: string
  isBack?: boolean
  isExternal?: boolean
  customNavButton?: CustomNavButtonProp
  onBack?: () => void
  paddingZero?: boolean
  bgColor?: string
  customContentClassName?: string
  customContentAppClassName?: string
}

const LayoutWrapper: React.FC<RoutingAppProps> = ({
  title,
  titleIconOrBadge,
  actions: Actions,
  component: Component,
  children,
  isSidePanelOpened = false,
  subHeading,
  isBack = false,
  isExternal = false,
  customNavButton,
  onBack,
  paddingZero,
  bgColor,
  customContentClassName,
  customContentAppClassName,
}) => {
  const { classes } = useStyles({
    isSidePanelOpened,
    isExternal,
    paddingZero,
    bgColor,
  })

  return (
    <div className={classes.root}>
      <div
        className={clsx(classes.content, customContentClassName)}
        id="content-id"
      >
        {title && (
          <HeaderRoutingApp
            title={title}
            actions={Actions}
            subHeading={subHeading}
            isBack={isBack}
            customNavButton={customNavButton}
            onBack={onBack}
            isExternal={isExternal}
            titleIconOrBadge={titleIconOrBadge}
          />
        )}

        <div
          data-testid="app-body"
          className={clsx(classes.appBody, customContentAppClassName)}
        >
          {Component ? (
            <WithErrorBoundary boundary="LayoutWrapper">
              <Component />
            </WithErrorBoundary>
          ) : (
            children
          )}
        </div>
      </div>
    </div>
  )
}

const NoHeaderLayoutWrapper: React.FC<RoutingAppProps> = ({
  component: Component,
  children,
  isSidePanelOpened = false,
  isExternal = false,
}) => {
  const { classes } = useStyles({ isSidePanelOpened, isExternal })
  return (
    <div className={classes.root}>
      <div className={classes.content} id="content-id">
        <div data-testid="app-no-body">
          {Component ? (
            <WithErrorBoundary boundary="NoHeaderLayoutWrapper">
              <Component />
            </WithErrorBoundary>
          ) : (
            children
          )}
        </div>
      </div>
    </div>
  )
}

export { LayoutWrapper, NoHeaderLayoutWrapper }
